<template>
  <div class="container">
    <div class="top">
      <div class="top_left" @click="gaback">
        <img src="@/assets/newMedal/time/left2.png" alt="" />
      </div>
      <div class="top_center">{{ cardItem.medalTypeName }}</div>
      <!-- <div class="top_center">荣耀登顶</div> -->
      <div class="topRight"></div>
    </div>
    <div class="info_left">
      <img :src="$store.state.userInfo.icon" alt="" />
      <div class="info_base">
        <div>{{ $store.state.userInfo.nickname }}</div>
        <div>{{ $store.state.userInfo.position }}</div>
      </div>
    </div>
    <div class="info_right">
      <div class="info_right_num">
        <span>{{ number }}</span
        >枚
      </div>
      <div class="info_right_text">荣誉勋章</div>
    </div>

    <div class="swiper_con">
      <swiper :options="swiperOptions">
        <swiper-slide v-for="(project, index) in projects" :key="index">
          <div class="content">
            <div class="imgBox">
              <img
                v-if="number > 0"
                class="img2"
                :src="imgUrl + project.iconId"
                alt=""
              />
              <img v-else class="img2" :src="imgUrl + project.fileId" alt="" />
            </div>
            <h2 v-if="number > 0" class="title_con">
              {{ project.title }}
            </h2>
            <h2 v-else>未解锁</h2>
            <p v-if="number > 0">
              恭喜您！您所参与的「{{
                project.title
              }}」项目，<br />荣耀加冕，荣获了「{{ badgeItem.medalName }}」！
            </p>
            <p v-else class="unlock_con">
              {{ project.unlockDescribe }}
            </p>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <!-- 自定义分页器 -->
    <div class="swiper-pagination" slot="pagination"></div>
    <div class="date" v-if="number > 0">
      于{{ projects[activeIndex]?.update_time }}点亮勋章
    </div>
    <div class="btn">
      <el-button @click="toDetail(projects[activeIndex])">查看详情</el-button>
    </div>
    <div class="logo">
      <img src="../../../../assets/newMedal/time/logo.svg" alt="" />
    </div>
  </div>
</template>

<script>
import api from "@/apis/medal";
// import { getToken } from "@/utils/cookie";
import moment from "moment";
export default {
  components: {},
  data() {
    let _this = this;
    return {
      projects: [],
      activeIndex: 0,
      number: 0,
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 30,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        on: {
          init: function () {
            _this.activeIndex = this.realIndex;
          },
          slideChange: function () {
            _this.activeIndex = this.realIndex;
          }
        }
      },
      imgUrl: "",
      cardItem: {},
      badgeItem: {}
    };
  },
  mounted() {
    this.imgUrl = api.imgUrl;
    this.cardItem = JSON.parse(localStorage.getItem("cardItem"));
    this.badgeItem = JSON.parse(localStorage.getItem("badgeItem"));
    this.queryMyBadge();
  },
  methods: {
    // 返回上一页
    gaback() {
      localStorage.setItem("tabValue", JSON.stringify(this.cardItem.id));
      this.$router.go(-1);
    },
    //跳转徽章详情
    toDetail(info) {
      if (this.number!=0) {
        this.$router.push({
          path: "/mobile/medal/newsNotice/medalDetail",
          query: {
            id: info?.recordId
          }
        });
      } else {
        return this.$message({
          type: "warning", // success error warning
          message: '您还未获取该勋章！',
          duration: 2000
        });
      }
    },
    // 查询我的徽章
    queryMyBadge() {
      api
        .medalProjectManagementApi({
          medalId: this.badgeItem.id,
          empno: this.$route.query.token
        })
        .then(res => {
          if (res.code == 200) {
            this.number = res.data.number;
            this.projects = res.data.list.map(item => {
              item.update_time = item.update_time
                ? moment(item.update_time).format("YYYY/MM/DD")
                : item.update_time;
              return item;
            });
            if (res.data.list.length == 0) {
              this.projects = [this.badgeItem];
            }
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
.container {
  width: 100%;
  height: 100%;
  background: url("~@/assets/newMedal/bg7.png");
  background-size: 100% 100%;
  padding: 60px 30px 30px;
  overflow: hidden;
  position: relative;
  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 30px;
    color: #fff;
    div {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .top_center {
      // margin-left: -15%;
    }
  }
  .info_left {
    display: flex;
    align-items: center;
    position: absolute;
    top: 15%;
    left: 6%;
    img {
      width: 95px;
      height: 95px;
      border: 10px solid #ba9069;
      border-radius: 50%;
    }
    .info_base {
      font-size: 26px;
      color: #fff;
      margin-left: 20px;
      div:nth-child(1) {
        color: #ffc974;
        font-size: 34px;
        font-weight: bold;
        margin-bottom: 15px;
      }
    }
  }
  .info_right {
    position: absolute;
    top: 15%;
    right: 11.5%;
    color: #fff;
    .info_right_num {
      font-size: 26px;
      text-align: center;
      margin-bottom: 1px;
      span {
        font-size: 66px;
        color: #ffc974;
        font-weight: bold;
      }
    }
    .info_right_text {
      font-size: 24px;
      text-align: center;
    }
  }
  .imgBox {
    .img2 {
      width: 480px;
      height: 480px;
      // position: absolute;
      // top: 23%;
      // left: 50%;
      // transform: translateX(-50%);
      // z-index: 99;
    }
  }
  .swiper_con {
    position: absolute;
    top: 22vh;
    left: 0;
    width: 100%;
    height: 55vh;
    .swiper-slide {
      width: 100% !important;
      height: 100%;
    }
    .content {
      width: 100%;
      color: #fff;
      text-align: center;
    }
    .content h2 {
      font-size: 36px;
    }
    .content p {
      font-size: 26px;
    }
    .title_con {
      padding: 0 40px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .unlock_con {
      padding: 0 40px;
      // overflow: hidden;
      // text-overflow: ellipsis;
      // display: -webkit-box;
      // -webkit-line-clamp: 2;
      // -webkit-box-orient: vertical;
    }
    .date {
      color: #ccc;
    }
  }

  .date {
    position: absolute;
    top: 74%;
    left: 50%;
    transform: translateX(-50%);
    font-size: 26px;
    color: #fff;
  }
  .btn {
    position: absolute;
    top: 80%;
    left: 50%;
    transform: translateX(-50%);
    .el-button {
      width: 450px;
      height: 80px;
      background: linear-gradient(78deg, #b98f68 2%, #eec696 91%);
      border: none;
      border-radius: 100px;
      color: #391f06;
      font-size: 30px;
      font-weight: bold;
    }
  }
  .logo {
    position: absolute;
    bottom: 4%;
    left: 50%;
    transform: translateX(-50%);
  }
  ::v-deep {
    .swiper-pagination {
      width: 100%;
      height: 60px;
      bottom: 26vh;
      left: 0;
    }

    .swiper-pagination-bullet {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #fff;
      margin: 0 5px;
    }
    .swiper-pagination-bullet-active {
      background-color: #eec696;
    }
  }
}
</style>
